import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { BaseComponent } from '../../../base-component/base.component';
import { getLanguageByShortcut, languages } from '@utils/language.utils';
import { NgClass } from '@angular/common';

import { TempLangService } from '@shared/services/localisation/temp-lang.service';
import { LanguageService } from '@shared/services/localisation/language.service';
import { CurrentUserService } from '@src/app/features/authentication/services/current-user.service';
import { MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelActionRow } from '@angular/material/expansion';
import { MatMenuItem } from '@angular/material/menu';

@Component({
  selector: 'stx-language-temp',
  templateUrl: './language-temp.component.html',
  styleUrls: ['./language-temp.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelActionRow, MatMenuItem, NgClass, TranslateModule]
})
export class LanguageTempComponent extends BaseComponent implements OnInit {
  readonly translateService = inject(TranslateService);
  private readonly languageService = inject(LanguageService);
  private readonly authService = inject(CurrentUserService);
  private readonly changeDetector = inject(ChangeDetectorRef);
  private readonly tempLangService = inject(TempLangService);

  activeTempLang: string;
  showTempLangSwitcher = true;

  ngOnInit() {
    this.activeTempLang = getLanguageByShortcut(this.authService.getCurrentUser()?.tempLang)?.name;
    this.changeDetector.markForCheck();
    this.subSink.sink = this.authService.user$.subscribe(user => {
      if (user) {
        if (!user.tempLang) {
          this.activeTempLang = null;
          this.languageService.switchLanguage(getLanguageByShortcut(user.lang).name);
        } else if (user.tempLang) {
          this.languageService.switchLanguage(getLanguageByShortcut(user.tempLang).name);
        }
      }
    });
  }

  switchLanguage(lang: string): void {
    let newTempLang = null;
    if (this.activeTempLang === lang) {
      this.activeTempLang = null;
    } else {
      this.activeTempLang = lang;
      newTempLang = languages.find(language => language.name === lang)?.shortcut;
    }

    this.authService.updateCurrentUser({
      ...this.authService.getCurrentUser(),
      tempLang: newTempLang
    });
    this.tempLangService.setTempLanguage(newTempLang);
  }
}
